export interface IPartnerCommission {
  name: string;
  email: string;
  total_sales: number;
  total_gain: number;
}

export enum EDateTypes {
  REFUNDED = 'refunded_at',
  PAID = 'received_at',
}

export interface IRefundFilter {
  date_type: EDateTypes;
  date: [string, string];
  product_id?: number[];
  invoice_id: string;
  motive_id: string[];
}
